module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/dress_lineup-d5df827ecfbcc69b09b5c13ca1f2c4eb.jpg";